import { Divider, Row } from "antd";
import { PaymentDetailsProps } from "./PaymentDetails";
import { useGetIcon } from "../../hooks/useGetIcon";
import { useMemo } from "react";
import dayjs from "dayjs";
import { PAYMENT_METHODS } from "../../../../../lib/constants";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";

export const PaymentInfo = ({ paymentRecord }: PaymentDetailsProps) => {
  const { getIcon } = useGetIcon();

  const paymentOption = useMemo(() => {
    if (paymentRecord.method === 10) {
      const disb = paymentRecord.disbursements.find((d: any) => d.type === 101);

      return {
        title: "PAYMENT FROM IMPOUND",
        icon: getIcon("ImpoundDistribution"),
        amount: disb?.amount ?? paymentRecord.amount,
      };
    }
    if (paymentRecord.type === 1) {
      return {
        title: "REGULAR PAYMENT",
        icon: getIcon("RegularPayment"),
        amount: paymentRecord.amount,
      };
    }
    if (paymentRecord.type === 2) {
      return {
        title: "ONE-TIME PAYMENT",
        icon: getIcon("OneTimePayment"),
        amount: paymentRecord.amount,
      };
    }
    if (paymentRecord.type === 3) {
      return {
        title: "PAYOFF PAYMENT",
        icon: getIcon("PayoffPayment"),
        amount: paymentRecord.amount,
      };
    }
  }, [getIcon, paymentRecord]);

  return (
    <>
      <Row className="w-100 mb-2">
        <Row>{paymentOption?.icon}</Row>
        <Row>
          <p className="text-md w-300 ml-2 mb-0 mt-0">{paymentOption?.title}</p>
        </Row>
      </Row>
      <Row className="w-100 d-block mt-3">
        <p className="h h4">{getFormattedCurrency(paymentOption?.amount)}</p>
        <p className="text-md title mt-0">
          {dayjs(paymentRecord.date).format("MMMM D, YYYY")}
        </p>
      </Row>
      <Divider></Divider>
      <Row className="w-100 d-block">
        <p className="text-md title mb-0">Due Date</p>
        <p className="text-md mt-0">
          {dayjs(paymentRecord.dueDate).format("MMMM D, YYYY")}
        </p>
      </Row>
      <Row className="w-100 d-block">
        <p className="text-md title mb-0">Interest To</p>
        <p className="text-md mt-0">
          {dayjs(paymentRecord.interestDateTo).format("MMMM D, YYYY")}
        </p>
      </Row>
      <Row className="w-100 d-block">
        <p className="text-md title mb-0">Method</p>
        <p className="text-md mt-0 mb-0">
          {
            PAYMENT_METHODS.find(
              (method) => method.value === paymentRecord.method,
            )?.label
          }
        </p>
      </Row>
    </>
  );
};
